import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

export const useLimitIdParam = (): string => {
  const { limitId } = useParams<{ limitId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!limitId) {
      navigate("/");
    }
  }, [limitId, navigate]);

  if (!limitId) {
    throw new Error("limitId is required but was not found in route params");
  }

  return limitId;
};
